import React from "react";
import { Form } from "react-bootstrap";

export default function Layout({
  header,
  children,
  goBack,
  goBackText = "Go Back",
}) {
  return (
    <div className="orenda-frontend">
      {header && <p className="widgethead">{header}</p>}
      {children}
      {goBack && (
        <Form.Group controlId="back" className="my-3">
          <div className="textlink back" onClick={goBack}>
            {goBackText}
          </div>
        </Form.Group>
      )}
    </div>
  );
}
